var render, staticRenderFns
import script from "./tableMemberProductLink.vue?vue&type=script&lang=js&"
export * from "./tableMemberProductLink.vue?vue&type=script&lang=js&"
import style0 from "./tableMemberProductLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a5492",
  null
  
)

export default component.exports